module.exports = __webpack_public_path__ + "media/reskin-images/img--get-access-free-video-118cb949.png";